// Medios con los que se cobró una venta de Cantina. Una venta anterior al
// pago dividido (sin segundo medio) tiene un solo medio por el total.
export function mediosDeVenta(venta) {
  const primero = {
    nombre: venta?.medioPago?.nombre || '—',
    monto: venta?.medioPago2
      ? Number(venta?.monto_medio_pago_1 ?? 0)
      : Number(venta?.total ?? 0),
  };

  if (!venta?.medioPago2 && !venta?.medio_pago_id_2) {
    return [primero];
  }

  return [
    primero,
    {
      nombre: venta?.medioPago2?.nombre || '—',
      monto: Number(venta?.monto_medio_pago_2 ?? 0),
    },
  ];
}
